export default __webpack_public_path__ + "static/media/endRound7.db0f02d1.mp3";